export const IPC_RENDERER_KEY_PREFIX = 'rxdb-ipc-renderer-storage';
export const IPC_RENDERER_TO_MAIN = 'rxdb-renderer-to-main';
